/* eslint-disable import/no-named-as-default */

import PropTypes from "prop-types";
import React from "react";
import {hot} from "react-hot-loader";
import {Route, Switch} from "react-router-dom";
import ImeiSearchPage from "./ImeiSearchPage";

class App extends React.Component {
  render() {
    return (
      <div>

        <header>
          <div className="l-System">
            <header className="g-Header">
              <div className="g-Header_Container">
                <div className="g-Header_Logo"><a href="/">Rakuten Mobile</a>
                </div>
              </div>
            </header>
          </div>
        </header>

        <section>

          <div className="inner">

            <h1>ネットワーク利用制限携帯電話機の確認</h1>
            <Switch>
              <Route path="/" component={ImeiSearchPage}/>
              {/*<Route render={() => { window.location.replace("https://mobile.rakuten.co.jp/error/404.html"); }}/>*/}
            </Switch>
            {this.props.children}


          </div>

        </section>

      </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.element
};

export default hot(module)(App);
